export default __webpack_public_path__ + "static/media/c006-5.d39581cb.jpg";